import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import type { Theme } from "@/shared/contexts/ThemeProvider";
import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/shared/ui/DropDownMenu";

const OPTIONS: { value: Theme, label: string, icon: typeof Sun }[] = [
  { value: "light", label: "Clair", icon: Sun },
  { value: "dark", label: "Sombre", icon: Moon },
  { value: "system", label: "Système", icon: Monitor },
];

/**
 * Groupe « Apparence », à placer dans un DropdownMenu existant.
 */
export const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();
  const [isMounted, setIsMounted] = useState(false);

  // next-themes ne connaît le choix stocké qu'après le montage : afficher le
  // menu avant ferait clignoter la puce sur la mauvaise option.
  useEffect(() => setIsMounted(true), []);

  return (
    <>
      <DropdownMenuLabel className="text-muted-foreground text-xs font-normal">
        Apparence
      </DropdownMenuLabel>
      <DropdownMenuRadioGroup
        value={isMounted ? theme : undefined}
        onValueChange={setTheme}
      >
        {OPTIONS.map(({ value, label, icon: Icon }) => (
          <DropdownMenuRadioItem
            key={value}
            value={value}
            className="cursor-pointer"
          >
            <Icon className="size-4" />
            {label}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </>
  );
};

export default ThemeSwitcher;
